import React, { useState, useEffect, forwardRef, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import { getFormattedDate, YYYY_MM_DD_FORMAT, changeDateToGivenFormat, getCurrentDate } from '../../../../../../../Utils/DateUtils';
import _ from 'lodash-es';
import Popup from '../../../../../Common/Popup/Popup';
import { CustomDynamicForm } from '../../../../../Common/CustomForm/CustomDynamicForm';
import { getLumpingFaciltyReducer } from '../../../../../../../redux/reducers/reducerSlices/GetLumpingFaciltyReducer';
import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import { sortArrByKey } from '../../../../../../Assests/Utility';
import TruckUnloadSummaryList from './ListComponent/TruckUnloadSummaryList';
import { usePrevious } from '../../../../../Common/CustomHooks/usePrevious';
import DownloadSection from '../../../DownloadSection/DownloadSection';
import ReportsInput from '../Components/ReportsInputs';
import moment from 'moment';
import './TruckUnloadSummary.css'
import DownloadSectionBECustomFeilds from '../../../DownloadSection/DownloadSectionBECustomFeilds';
import { getRemoteConfigSelector } from '../../../../../../../redux/reducers/reducerSlices/RemoteConfigReducer';
import { smartScheduleSelector } from '../../../../../../../redux/reducers/reducerSlices/SmartScheduleReducer';
import { format } from 'date-fns';
import { getReportsSelector } from '../../../../../../../redux/reducers/reducerSlices/ReportsReducerSlice';

const TruckUnloadSummary = (props) => {
    const dispatch = useDispatch();
    const { themeSelected } = props;
    const [showModal, setShowModal] = useState(false);
    const lumpingFacilityData = useSelector(getLumpingFaciltyReducer);
    const user = useSelector(getUserSelector);
    const { userType, parentWarehouse, userAccountDetails, } = user;
    const [lumpingFacDataArr, setLumpingFacDataArr] = useState([]);
    const [selectedLumpingFacility, setSelectedLumpingFacility] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [warehouseListState, setWarehouseListState] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentCustomCalendarType, setCurrentCustomCalendarType] = useState('today');
    const [currentCalendarType, setCurrentCalendarType] = useState('');
    const divRef = useRef(null);
    const [editData, setEditData] = useState({});
    const [currentTable, setCurrentTable] = useState(null);
    const [currentTableRef, setCurrentTableRef] = useState(null);
    const [apiParams, setApiParams] = useState([]);
    const previousTable = usePrevious(currentTable);
    const [particularFieldValue, setParticularFieldValue] = useState("");
    const ss = useSelector(smartScheduleSelector);
    const { isDownloadLoading } = ss;
    const remoteConfig = useSelector(getRemoteConfigSelector);
    const { allConfigration } = remoteConfig;
    const { PaginationDefaultLimit } = allConfigration
    const [payload, setPayload] = useState({});
    const [startDateState, setStartDateState] = useState(changeDateToGivenFormat(getCurrentDate(), AppConstant.commonStrings.MM_DD_YYYY_dateFormat))
    const [endDateState, setEndDateState] = useState(changeDateToGivenFormat(getCurrentDate(), AppConstant.commonStrings.MM_DD_YYYY_dateFormat))
    const [showDateRange, setShowDateRange] = useState(false);
    const [startTimeState, setStartTimeState] = useState(new Date());
    const [endTimeState, setEndTimeState] = useState(new Date());
    const [onDockValue, setOnDockValue] = useState('');
    useEffect(() => {
        const container = divRef.current;
        const tables = container.querySelectorAll('table');
        if (tables && tables.length && _.isEqual(currentTable, previousTable)) {
            setCurrentTableRef(container);
            setCurrentTable(tables);
        }
    })

    useEffect(() => {
        if (lumpingFacilityData.data) {
            const { IDLumpingFacility } = parentWarehouse;
            const tempArr = lumpingFacilityData.data.filter(el => el.ID === IDLumpingFacility)
            setLumpingFacDataArr(tempArr);
        }
    }, [lumpingFacilityData.data])

    useEffect(() => {
        setShowModal(true)
        setSelectedLumpingFacility([])
        setWarehouseListState([])
        setLumpingFacDataArr([])
        dispatch({ type: sagaActions.GET_LUMPING_FACILTY_DATA });
        const { userPermission } = AppConstant;
        if (userType === userPermission.usertypes.user) {
            setWarehouseListState([parentWarehouse])
            setParticularFieldValue({ warehouse_id: parentWarehouse.ID, lumping_facility_id: parentWarehouse.IDLumpingFacility, on_dock: 'False' });
        }
        dispatch({ type: sagaActions.CLEAR_TRUCK_UNLOAD_LIST });
    }, [])

    const getLumpingFacilityList = () => {
        return (
            lumpingFacDataArr &&
            lumpingFacDataArr.map((data, index) => {
                return (
                    <option key={data.ID} value={data.ID}>
                        {data.Description}
                    </option>
                );
            })
        );
    };

    const getWarehousesList = () => {
        return (
            warehouseListState &&
            warehouseListState.map((data, index) => {
                return (
                    <option key={data.ID} value={data.ID}>
                        {data.Name}
                    </option>
                );
            })
        );
    };

const getOnDockOptions = () => {
    return [
        { value:  'True', label: 'True' },
        { value: 'False', label: 'False' },
    ].map(opt => <option key={String(opt.value)} value={opt.value}>{opt.label}</option>);
};

    const getTimePeriodList = () => {
        const timePeriodArr = ['Monthly', 'Weekly', 'Daily', 'Today', 'Custom']
        return (
            timePeriodArr &&
            timePeriodArr.map((data, index) => {
                return (
                    <option key={data} value={data}>
                        {data}
                    </option>
                );
            })
        );
    };


    // const getFormFieldData = (data, name) => {
    //     if (!name || typeof name !== 'string') {
    //         return;
    //     }

    //     if (data === undefined || data === null) {
    //         return;
    //     }


    //     if (name === 'period_id') {
    //         const periodValue = data?.toUpperCase();

    //         if (periodValue === 'CUSTOM') {
    //             setShowDateRange(true);
    //             setCurrentCalendarType(data);
    //             setParticularFieldValue(prev => ({
    //                 ...prev,
    //                 period_id: data,
    //                 'custom-date-picker': ''
    //             }));
    //             setSelectedDate('');
    //         } else {
    //             setShowDateRange(false);
    //             setCurrentCalendarType(data);

    //             if (periodValue === 'TODAY') {
    //                 const currentFormattedDate = changeDateToGivenFormat(getCurrentDate(), AppConstant.commonStrings.MM_DD_YYYY_dateFormat);
    //                 setParticularFieldValue(prev => ({
    //                     ...prev,
    //                     period_id: data,
    //                     'custom-date-picker': currentFormattedDate
    //                 }));
    //                 setSelectedDate(currentFormattedDate);
    //             } else {
    //                 setParticularFieldValue(prev => ({
    //                     ...prev,
    //                     period_id: data,
    //                     'custom-date-picker': ''
    //                 }));
    //                 setSelectedDate('');
    //             }
    //         }

    //         return;
    //     }

    //     if (name === 'start_date') {
    //         setParticularFieldValue(prev => ({
    //             ...prev,
    //             start_date: data,
    //             end_date: ''
    //         }));
    //         setStartDateState(data);
    //     } else if (name === 'end_date') {
    //         setEndDateState(data);
    //     } else if (name === 'custom-date-picker') {
    //         const formattedDate = changeDateToGivenFormat(data, AppConstant.commonStrings.MM_DD_YYYY_dateFormat);
    //         setShowDateRange(false);
    //         setSelectedDate(formattedDate);
    //     }
    // };

    const getFormFieldData = (data, name) => {
        if (!name || typeof name !== 'string') return;
        if (data === undefined || data === null) return;

        if (name === 'period_id') {
            const periodValue = data?.toUpperCase();

            if (periodValue === 'CUSTOM') {
                setShowDateRange(true);
                setCurrentCalendarType(data);
                setParticularFieldValue(prev => ({
                    ...prev,
                    period_id: data,
                    'custom-date-picker': ''
                }));
                setSelectedDate('');
            } else {
                setShowDateRange(false);
                setCurrentCalendarType(data);

                if (periodValue === 'TODAY') {
                    const currentFormattedDate = changeDateToGivenFormat(
                        getCurrentDate(),
                        AppConstant.commonStrings.MM_DD_YYYY_dateFormat
                    );
                    setParticularFieldValue(prev => ({
                        ...prev,
                        period_id: data,
                        'custom-date-picker': currentFormattedDate
                    }));
                    setSelectedDate(currentFormattedDate);
                } else {
                    setParticularFieldValue(prev => ({
                        ...prev,
                        period_id: data,
                        'custom-date-picker': ''
                    }));
                    setSelectedDate('');
                }
            }

            return;
        }

        if (name === 'start_date') {
            setStartDateState(data);
            setParticularFieldValue(prev => ({
                ...prev,
                start_date: data,
                end_date: '' // reset end date when start date changes
            }));
        } else if (name === 'end_date') {
            setEndDateState(data);
            setParticularFieldValue(prev => ({
                ...prev,
                end_date: data
            }));
        } else if (name === 'custom-date-picker') {
            const formattedDate = changeDateToGivenFormat(
                data,
                AppConstant.commonStrings.MM_DD_YYYY_dateFormat
            );
            setShowDateRange(false);
            setSelectedDate(formattedDate);
            setParticularFieldValue(prev => ({
                ...prev,
                'custom-date-picker': formattedDate
            }));
        } else if (name === 'start_time') {
            setStartTimeState(data);
            setParticularFieldValue(prev => ({
                ...prev,
                start_time: data
            }));
        } else if (name === 'end_time') {
            setEndTimeState(data);
            setParticularFieldValue(prev => ({
                ...prev,
                end_time: data
            }));
        } else if (name === 'on_dock') {
            // const booleanValue = (data === 'true' || data === true);
            setOnDockValue(data);
            setParticularFieldValue(prev => ({
                ...prev,
                on_dock: data
            }));
        }
    };


    const getSummitedFormData = (data) => {
        if (!data || typeof data !== 'object') {
            return;
        }

        if (!data.start_date) {
            data.start_date = new Date();
        }
        if (!data.end_date) {
            data.end_date = new Date();
        }

        const apiParams = {
            "IDLumpingFacility": data?.lumping_facility_id,
            "IDWarehouse": data?.warehouse_id,
            "PeriodType": data?.period_id,
            "dock_id": null,
            "onDock": particularFieldValue?.on_dock === 'True' ? true: false,
            "Date": data?.period_id.toUpperCase() != 'CUSTOM' ? getFormattedDate(YYYY_MM_DD_FORMAT, data['custom-date-picker']) : null,
            "startDate": data?.period_id.toUpperCase() === 'CUSTOM' ? combineDateAndTime(data?.start_date, data?.start_time, true) : null,
            "endDate": data?.period_id.toUpperCase() === 'CUSTOM' ? combineDateAndTime(data?.end_date, data?.end_time, true) : null,
        }
        const selectedLumper = (_.find(lumpingFacDataArr, { ID: data?.lumping_facility_id }));
        const selectedWarehouse = (_.find(warehouseListState, { ID: data?.warehouse_id }));

        const paramsArr = [
            { "Lumping Facility ": selectedLumper?.Description || '' },
            { "Warehouse": selectedWarehouse?.Name || '' },
            { "Time Period": data?.period_id || '' },
            { "Date": data['custom-date-picker'] ? changeDateToGivenFormat(data['custom-date-picker'], AppConstant.commonStrings.MM_DD_YYYY_dateFormat) : '' },
        ];
        apiParams.pdfHeaderSection = paramsArr;
        
        setPayload(apiParams);


        if (data.period_id.toUpperCase() === 'CUSTOM') {
            paramsArr.push(
                { "Start Date": data?.start_date ? combineDateAndTime(data?.start_date, data?.start_time, false) : '' },
                { "End Date": data?.end_date ? combineDateAndTime(data?.end_date, data?.end_time, false) : '' },
            );
        }

        if (particularFieldValue?.on_dock !== undefined) {
            paramsArr.push(
                { "On Dock": String(particularFieldValue?.on_dock) }
            );
        }

        setApiParams(paramsArr);

        dispatch({ type: sagaActions.INTIATE_LOADER_REPORTS, payload: true });
        dispatch({ type: sagaActions.GET_TRUCK_UNLOAD_SUMMARY_LIST, payload: apiParams });
        setShowModal(false);
    };

    const combineDateAndTime = (date, time, addTimeZone) => {
        if (!date || !time) return null;

        // Extract date and time parts separately
        const datePart = moment(date).format('YYYY-MM-DD');

        // Convert to UTC and format
        if (addTimeZone) {
        return `${datePart}T${time}:00Z`;
        } 
        return `${moment(date).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)} ${time}`;
    };



    const TUSDatePickerInput = forwardRef(({ value, onClick }, ref) => (
        <button className="customDatePickerInput" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const TUSTimePickerInput = forwardRef(({ value, onClick }, ref) => {
        let dateStr = moment(value).hours() + ':' + moment(value).minutes();
        if (!value.includes('mm')) {
            const getHour = ("0" + moment(value).hour()).slice(-2);
            const getMin = ("0" + moment(value).minutes()).slice(-2);
            dateStr = getHour + ":" + getMin;
        }

        return (
            <button className="customDatePickerInput" onClick={onClick} ref={ref}>
                {dateStr !== 'NaN:NaN' ? dateStr : 'HH:MM'}
            </button>
        )
    });

    const selectedDateValue = () => {
        if (selectedDate) {
            return selectedDate
        } else if (currentCalendarType === 'Today') {
            return changeDateToGivenFormat(getCurrentDate(), AppConstant.commonStrings.MM_DD_YYYY_dateFormat)
        } else {
            return AppConstant.commonStrings.MM_DD_YYYY_dateFormat
        }
    }

    const formFieldList = [
        {
            name: "lumping_facility_id",
            type: "select",
            size: "col-sm-6",
            position: 1,
            placeHolder: 'Select Lumping Company',
            title:
                AppConstant.reports.truckUnloadSummaryReport.selectLumpingFacility,
            formValidation: {
                required: true,
            },
            getSelectData: getLumpingFacilityList,
        },
        {
            name: "warehouse_id",
            type: "select",
            size: "col-sm-6",
            position: 1,
            title:
                AppConstant.reports.truckUnloadSummaryReport.warehouse,
            formValidation: {
                required: true,
            },
            getSelectData: getWarehousesList,
        },
        {
            name: "period_id",
            type: "select",
            size: "col-sm-6",
            position: 2,
            title:
                AppConstant.reports.truckUnloadSummaryReport.selectTimePeriod,
            formValidation: {
                required: true,
            },
            getSelectData: getTimePeriodList,
        },
        {
            size: "col-sm-6 mt-1",
            name: "custom-date-picker",
            type: "custom-date-picker",
            customDatePickerConfig: {
                calendarType: currentCalendarType,
                selectedDate: selectedDateValue(),
                customInput: <TUSDatePickerInput />,
                disableCalendar: (currentCalendarType !== '' ? (currentCalendarType === 'Today' ? true : false) : true),
            },
            position: 2,
            value: selectedDate,
            title:
                AppConstant.reports.truckUnloadSummaryReport.selectDate,
            formValidation: {

                required: !showDateRange,
            },
            hideElement: {
                isHidden: !showDateRange
            }
        },

        {
            size: "col-sm-6 mt-1",
            name: "start_date",
            type: "custom-date-picker",
            customDatePickerConfig: {
                name: "start_date",
                calendarType: currentCustomCalendarType,
                selectedDate: startDateState,
                customInput: <TUSDatePickerInput />
            },
            position: 3,
            value: startDateState,
            title:
                AppConstant.reports.truckUnloadSummaryReport.startDate,
            formValidation: {
                required: showDateRange,
            },
            hideElement: {
                isHidden: showDateRange
            }
        },
        {
            size: "col-sm-6 mt-1",
            name: "end_date",
            type: "custom-date-picker",
            customDatePickerConfig: {
                name: "end_date",
                calendarType: currentCustomCalendarType,
                selectedDate: endDateState,
                startDate: startDateState,
                maxDate: startDateState ? moment(startDateState).add(1, 'months').toDate() > moment().toDate() ? new Date() : moment(startDateState).add(1, 'months').toDate() : null,
                minDate: startDateState ? new Date(startDateState) : null,
                customInput: <TUSDatePickerInput />
            },
            position: 3,
            value: endDateState,
            title:
                AppConstant.reports.truckUnloadSummaryReport.endDate,
            formValidation: {
                required: showDateRange,
            },
            hideElement: {
                isHidden: showDateRange
            }
        },
        {
            size: "col-sm-6 mt-1",
            name: "start_time",
            type: "custom-time-selector", // <-- you'll define this
            customDatePickerConfig: {
                name: "start_time",
                showTimeSelect: true,
                showTimeSelectOnly: true,
                selectedDate: startTimeState,
                timeIntervals: 30,
                timeCaption: "Time",
                customInput: <TUSTimePickerInput value={startTimeState} />
            },
            position: 4,
            value: startTimeState ? startTimeState : "",
            title: "Start Time",
            formValidation: {
                required: showDateRange,
            },
            hideElement: {
                isHidden: showDateRange
            }
        },
        {
            size: "col-sm-6 mt-1",
            name: "end_time",
            type: "custom-time-selector", // <-- you'll define this
            customDatePickerConfig: {
                name: "end_time",
                selectedDate: endTimeState,
                showTimeSelect: true,
                showTimeSelectOnly: true,
                timeIntervals: 30,
                timeCaption: "Time",
                customInput: <TUSTimePickerInput value={endTimeState} />
            },
            position: 4,
            value: endTimeState ? endTimeState : "",
            title: "End Time",
            formValidation: {
                required: showDateRange,
            },
            hideElement: {
                isHidden: showDateRange
            }
        },
        {
            name: "on_dock",
            type: "select",
            size: "col-sm-6",
            position: 5,
            title: "On Dock",
            value: onDockValue, // Add this line
            formValidation: {
                required: false,
            },
            getSelectData: getOnDockOptions,
        }
        

    ]

    const editClicked = (data) => {
    }

    const closepopup = () => {
        // setEditData({});
        setShowModal(false);
        setStartDateState('')
        setEndDateState('')
    }

    const submitbtnData = {
        show: true,
        text: AppConstant.reports.generateReportButtonTitle,
    };
    const cancelbtndata = {
        show: true,
        text: AppConstant.comments.resetbutton,
    };
    const createForm = () => {
        return (
            <CustomDynamicForm
                formFieldList={formFieldList}
                sort={true}
                cancelBtn={cancelbtndata}
                submitbtn={submitbtnData}
                themeSelected={themeSelected}
                getSummitedFormData={getSummitedFormData}
                getFormFieldData={getFormFieldData}
                editFormData={editData}
                setParticularFieldValue={particularFieldValue}
                loading={loading}
            />
        );
    };

    const popupObj = {
        id: "createWarehouseFormPopup1",
        modalLabel: "createWarehouseFormPopup1",
        showClose: true,
        showfooter: true,
        showHeader: true,
        sendDriverNotification: false,
        modalSize: "xl",
        title: AppConstant.reports.truckUnloadSummaryReport.createReport,
        bodyText: createForm(),
        subText: "",
        keyboard: false,
        backdrop: "static",
        footerBtn: {
            btn1: {
                show: true,
                text: AppConstant.comments.cancelCommentButtonTitle,
            },
            btn2: {
                show: true,
                text: AppConstant.reports.generateReportButtonTitle,
            },
        },
    };

    function showPopup() {
        setStartDateState('')
        setEndDateState('')
        setShowModal(true);
        setApiParams([]);
        setCurrentCalendarType('');
        setSelectedDate('');
        setShowDateRange(false);
        setOnDockValue('False'); // Reset onDockValue
        setParticularFieldValue({});
        dispatch({ type: sagaActions.CLEAR_TRUCK_UNLOAD_LIST });
        setTimeout(() => {
            setParticularFieldValue({ 
                warehouse_id: parentWarehouse.ID, 
                lumping_facility_id: parentWarehouse.IDLumpingFacility,
                on_dock: 'False' // Reset on_dock in particularFieldValue or set to a default
            });
        }, 100)
    }
    


    //Call Download Report API
    const downloadReport = (payload) => {
        dispatch({ type: sagaActions.DOWNLOAD_REPORT_COMMON, payload });
    }

    //used to prepare download data payload
    const downloadData = (type) => {
        let payloadData = {
            subDomain: "truckUnloadSummary",
            downloadType: type,
            fileName: "TruckUnloadSummary-" + userAccountDetails?.UserName,
            options: payload
        }
        return payloadData
    }

    //Colums List for download column specific report
    const columnList = [
        {
            name: "Dock",
            value: "Dock"
        },
        {
            name: "Trucks Unloads",
            value: "TrucksUnloaded"
        },
        {
            name: "Trucks-Unloaded(%) Vender",
            value: "TrucksUnloadedPct",
        },
        {
            name: "End-Pallets",
            value: "EndPallets",
        },
        {
            name: "Pallets-Per Hour",
            value: "PalletsperHour"
        },
        {
            name: "Avg.-Unload Time",
            value: "AvgUnloadTime"
        },
        {
            name: "Loads-Unloads Delay",
            value: "LoadswithUnloadDelay"
        },
        {
            name: "Avg.-Check-Out Time",
            value: "AvgCheckoutTime"
        },
        {
            name: "Loads-w/Check-Out Delay",
            value: "LoadswithCheckOutDelay"
        },
        {
            name: "Loads-Arrived Late",
            value: "LoadsArrivedLate"
        },
        {
            name: "Avg.-Door Assign-To Unload-Finish",
            value: "AvgDoorAssigntoUnloadFinish"
        },
        {
            name: "Avg.-Door Assign-To Bills-In",
            value: "AvgDoorAssigntoBillin"
        },
        {
            name: "Avg.-Bills In-To Unload-Start",
            value: "AvgBillintoLumpStart"
        },
        {
            name: "Avg.-Appt To-Bills-Out",
            value: "AvgAppttoBillout"
        },
    ]

    return (
        <div className="pt-2">

            <div className='container-fluid d-flex py-2 text-start justify-content-between'>
                <button
                    className={'addButton me-4'}
                    onClick={() => showPopup()}>
                    {
                        AppConstant.reports.truckUnloadSummaryReport.createReport
                    }
                </button>
                <div className='d-flex align-items-center'>
                    <DownloadSectionBECustomFeilds isSchedulePro={true} downloadData={downloadData} isLoading={isDownloadLoading} isDisabled={isDownloadLoading} columnList={columnList} downloadReport={downloadReport} />
                    {/* <DownloadSection root={''} subRoot={''} name={'Truck Unload Summary Report'} themeSelected={themeSelected} currentTable={currentTable} currentTableRef={currentTableRef} /> */}

                </div>
            </div>

            <div className="roleListTable mt-1">
                <Popup
                    {...popupObj}
                    showModal={showModal}
                    showfooter={false}
                    closepopup={closepopup}
                    themeSelected={themeSelected}
                />
            </div>
            <div ref={divRef} className='truckUnloadSummaryTable'>
                {
                    (apiParams && apiParams.length) ?
                        <div>
                            <div className="mx-2 container-fluid text-center graphHeading">{AppConstant.reports.truckUnloadSummaryReport.title}</div>
                            <ReportsInput apiParams={apiParams} />
                            <TruckUnloadSummaryList isLoading={loading} />
                        </div>
                        :
                        <div />
                }
            </div>
        </div>
    );
};

export default TruckUnloadSummary;
